import L from 'leaflet';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

const AddCenterControlPositions = () => {
  const map = useMap();

  useEffect(() => {
    let topCenter = map._controlCorners?.topcenter;
    let bottomCenter = map._controlCorners?.bottomcenter;

    const applyCenterStyle = (element) => {
      element.style.position = 'absolute';
      element.style.left = '50%';
      element.style.transform = 'translateX(-50%)';
    };

    const controlContainer = map.getContainer().querySelector('.leaflet-control-container');

    if (!controlContainer) return;

    // Only creates the topCenter DOM Node if one doesn't already exist
    if (!topCenter) {
      topCenter = L.DomUtil.create('div', 'leaflet-top leaflet-center', controlContainer);
      applyCenterStyle(topCenter);
      map._controlCorners['topcenter'] = topCenter;
    }

    // Only creates the bottomCenter DOM Node if one doesn't already exist
    if (!bottomCenter) {
      bottomCenter = L.DomUtil.create('div', 'leaflet-bottom leaflet-center', controlContainer);
      applyCenterStyle(bottomCenter);
      map._controlCorners['bottomcenter'] = bottomCenter;
    }

    return () => {
      if (map._controlCorners?.topcenter === topCenter) {
        delete map._controlCorners.topcenter; // Removes the field from the leaflet control corners
        topCenter.remove(); // Removes the node from the DOM
      }

      if (map._controlCorners?.bottomcenter === bottomCenter) {
        delete map._controlCorners.bottomcenter; // Removes the field from the leaflet control corners
        bottomCenter.remove(); // Removes the node from the DOM
      }
    };
  }, [map]);

  return null;
};
export default AddCenterControlPositions;
